import { render, staticRenderFns } from "./HeroHeader.vue?vue&type=template&id=3d2f0916&scoped=true&"
import script from "./HeroHeader.vue?vue&type=script&lang=js&"
export * from "./HeroHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f0916",
  null
  
)

export default component.exports